/* global AuEmbed */
import storageAvailable from "../../../../lib/storageAvailable"

/**
 * Gets an object from the query string of the current location
 * Only works with 1 level of nesting
 *
 * @example
 *    // http//www.example.com/page?foo[x]=bar&foo[y]=baz
 *    getParamObjectFromLocation('foo') //=> { x: 'bar', y: 'baz' }
 *
 * @param {string} paramName the param name of the object to extract
 * @returns {object}
 */
function getParamObjectFromLocation(paramName) {
  const query = window.location.search.substring(1)
  const allParams = new URLSearchParams(query)

  const object = {}
  allParams.forEach((value, key) => {
    const reg = new RegExp(paramName + "\\[([^\\]]*)\\]")
    const matched = key.match(reg)
    if (matched) {
      object[matched[1]] = value
    }
  })
  return object
}

/**
 * Synchronizes the experiments from the URL query params to the localStorage
 * The params are passed from the parent's iframe (dealer website) to the
 * iframe (autouncle domain).
 *
 * Then sets the GA dimension for running experiments
 *
 * To be run once on page load, as early as possible
 */
export default function syncParamsToLocalAbTesting() {
  // Cannot set up the experiment locally
  if (!storageAvailable("localStorage")) return

  const abTestingParams = getParamObjectFromLocation("exp")
  const experimentNamesFromParams = Object.keys(abTestingParams)
  if (experimentNamesFromParams.length) {
    const alreadyRunningExperimentNames = Object.keys(
      AuEmbed.AbTesting.getRunningExperiments()
    )

    experimentNamesFromParams.forEach((experimentName) => {
      if (!alreadyRunningExperimentNames.includes(experimentName)) {
        // This experiment was not initialized inside of the iframe, do it now
        AuEmbed.AbTesting.setup(
          experimentName,
          [],
          abTestingParams[experimentName]
        )
      }
    })
  }
}
